import axios from "axios"

// Base Adresse Nationale (BAN) — official French government address API.
// Free, no API key required. Docs: https://adresse.data.gouv.fr/api-doc/adresse
const BAN_API_URL = "https://api-adresse.data.gouv.fr/search/"

export default class AddressManager {

    /**
     * Search French addresses on the BAN API.
     * @param {string} query free text typed by the user (min 3 chars)
     * @param {string} type optional BAN type filter ("municipality", "street", "housenumber")
     * @returns array of { id, label, name, postcode, city }
     */
    static async searchAddresses(query, type) {
        if (!query || query.trim().length < 3) return []
        try {
            const params = { q: query.trim(), limit: 5, autocomplete: 1 }
            if (type) params.type = type
            const response = await axios.get(BAN_API_URL, { params })
            if (response.data && response.data.features) {
                return response.data.features.map((feature) => ({
                    id: feature.properties.id,
                    label: feature.properties.label,
                    name: feature.properties.name,
                    postcode: feature.properties.postcode,
                    city: feature.properties.city
                }))
            }
        } catch (error) {
            console.error("Address search failed", error)
        }
        return []
    }
}
